<template>
  <div class="mb-3 card ">
    <div class="card-header bg-secondary-3">
      Dominio Evaluado:
      <b>{{ value.area.name | empty }}</b>
    </div>
    <div class="card-body bg-secondary-3">
      <div class="row">
        <div class="col-md-1">
          <label class="data-name">Puntuación:</label>
          <validation-provider
            ref="score"
            v-slot="{ errors, failedRules }"
            :name="`Puntuación-${value.area.id}`"
            rules="required|between:0,100"
          >
            <custom-input
              ref="scoreInput"
              v-model="scoreText"
              class="w-100 "
              :custom-error-msg="getErrorMessage(failedRules)"
              :disabled="isReadOnly"
              :error="errors[0]"
              placeholder="0-100"
              @input="changeScore"
            />
          </validation-provider>
        </div>
        <div v-if="isEvaluatedResults" class="col-md-2">
          <label class="data-name">Nivel:</label>
          <div v-if="level" class="mt-1">
            <span class="rounded-pill px-3 py-1 fw-semibold" :style="badge">
              {{ level.name }}
            </span>
          </div>
        </div>
        <div class="col-md">
          <div v-if="isEvaluatedResults">
            <label class="data-name">Interpretación:</label>
            <custom-input v-model="model.comment" :disabled="isReadOnly" />
          </div>

          <div v-if="isWhodasCifCodes">
            <div class="row">
              <div class="col-md-3">
                <label class="data-name">
                  Dificultad Leve (Calificador 1):
                </label>

                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="model.qualifierOne"
                    custom-error-msg="El campo es requerido."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>

              <div class="col-md-3">
                <label class="data-name">
                  Dificultad Moderada (Calificador 2):
                </label>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="model.qualifierTwo"
                    custom-error-msg="El campo es requerido."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>

              <div class="col-md-3">
                <label class="data-name">
                  Dificultad Grave (Calificador 3):
                </label>

                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="model.qualifierThree"
                    custom-error-msg="El campo es requerido."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>

              <div class="col-12 mt-2">
                <label class="data-name">Descripción Observaciones:</label>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="model.comment"
                    custom-error-msg="El campo es requerido."
                    :disabled="isReadOnly"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import Categories from '@/utils/constants/vocationalEvaluationInstrumentAreaCategory.js';

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    levels: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scoreText: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isEvaluatedResults() {
      return this.value.area?.category === Categories.EvaluatedResults;
    },
    isWhodasCifCodes() {
      return this.value.area?.category === Categories.WhodasCifCodes;
    },
    level() {
      const scoreInvalid = [null, undefined, ''].includes(this.model.score);
      if (scoreInvalid || this.levels == null) return null;
      const score = Number(this.model.score);
      return this.levels.find(
        (l) => score >= Number(l.min) && score <= Number(l.max)
      );
    },
    badge() {
      if (!this.level) return {};
      const color = this.level.color || '#ddd';
      return {
        background: `${color}22`,
        border: `1px solid ${color}`,
        color: color,
      };
    },
    getErrorMessage() {
      return (failedRules) => {
        if (!failedRules) return null;
        if (failedRules.required) return 'El campo es requerido.';
        if (failedRules.between) return 'El valor debe estar entre 0 y 100.';
        return null;
      };
    },
  },
  watch: {
    'model.score': function(val) {
      const current = this.scoreText === '' ? null : Number(this.scoreText);
      if (val !== current) {
        this.scoreText = val === null || val === undefined ? '' : String(val);
      }
    },
  },
  created() {
    this.scoreText =
      this.model.score === null || this.model.score === undefined
        ? ''
        : String(this.model.score);
  },
  methods: {
    sanitizeScore(value) {
      let s = String(value == null ? '' : value).replace(/[^\d.]/g, '');
      const dot = s.indexOf('.');
      if (dot !== -1) {
        // mantener solo el primer punto y un único decimal
        s =
          s.slice(0, dot + 1) +
          s
            .slice(dot + 1)
            .replace(/\./g, '')
            .slice(0, 1);
      }
      return s;
    },
    changeScore(v) {
      const raw = String(v == null ? '' : v);
      const clean = this.sanitizeScore(v);
      this.scoreText = clean;
      const num = parseFloat(clean);
      this.model.score = Number.isNaN(num) ? null : num;

      if (raw !== clean) {
        this.$nextTick(() => {
          const input = this.$refs.scoreInput;
          if (input && typeof input.$forceUpdate === 'function') {
            input.$forceUpdate();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
